var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHowOurServicesWork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 477.31 339.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-22,.cls-5{fill:none;}.cls-2{isolation:isolate;}.cls-3{fill:#d2e5fa;}.cls-4{fill:#79e069;}.cls-5{stroke:#5aa64e;stroke-linecap:round;stroke-width:0.5px;}.cls-22,.cls-5{stroke-miterlimit:10;}.cls-6{fill:#fff;}.cls-7{fill:#d9d9d9;}.cls-8{fill:#f7204b;}.cls-9{fill:#faaf78;}.cls-10{fill:#ff9b21;}.cls-11{fill:#3d5d99;}.cls-12{fill:#7a7371;}.cls-13{fill:#99908e;}.cls-14{fill:#474342;}.cls-15{fill:#512566;}.cls-16{fill:#e69361;}.cls-17{fill:#371945;}.cls-18{fill:#430f82;opacity:0.43;mix-blend-mode:multiply;}.cls-19{fill:#bf7a47;}.cls-20{fill:#996239;}.cls-21{clip-path:url(#clip-path);}.cls-22{stroke:#3d5d99;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-12.97 -48.38)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M330.61,203.63l16.6,2.69a15.48,15.48,0,0,1,4.45,1.4c7.53,3.76,8,13.94,6.86,18.78l-6.89,27.33,2.6,14.26-7.78,2.41a47.89,47.89,0,0,1-17.75,2.12c-5.93-.43-9-1.9-14.17-5.08h0l3.05-25.38c-7-13.7,2.42-31.78,7-36.71a6.2,6.2,0,0,1,2.77-1.78A5.92,5.92,0,0,1,330.61,203.63Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M316.56,58.2c35.93,11.16,75,29.46,96.07,61.09,27.89,41.81,47.6,104.25,29.26,159-18.5,55.23-88,97.07-145.69,94.48-44.61-2-78.46-30.44-121.71-11.64-19,8.24-20.63,17.25-32,17.42-40.74.61-106.77-113.12-76-206.78C99.68,70.8,216.66,27.19,316.56,58.2Z",
    transform: "translate(-12.97 -48.38)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M156,346.55c8.9-6.83,20-3.81,23.57-3.44,6.16.64,7.43,5.1,12.22,4.59,7.44-.8,7.78-11.9,16.15-14.37,7.09-2.09,9.23,5.17,19.37,4.29,7.84-.67,9.56-5.27,18.68-5.45,3.43-.07,8.68-.17,11.23,3.24,3.62,4.82.81,15.25-5.09,18.8-6.92,4.16-13.43-3.94-21.11.06-7.36,3.84-5.14,13.23-12.05,16.33s-12.48-5.15-21.91-4.05-9.5,11.39-19.56,16.79c-13.57,7.28-34.66,1.33-36.73-7.47C139.14,368.81,143.05,356.52,156,346.55Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M147.77,344.51c1.74-12.71,13.37-19.45,16.64-22.11,5.61-4.56,10.32-2.09,13.86-6.44,5.48-6.75-3.36-15.78,1.53-24.61,4.13-7.48,11.86-3.53,19.51-12.55,5.92-7,3.56-12,10.95-19.68,2.78-2.87,7-7.27,11.93-6.69,6.95.83,13.2,11.36,11.25,19-2.3,9-14.33,7.94-17.38,17.42-2.92,9.07,6.62,14.65,3.46,22.77s-14.53,6.21-21.41,14.84,1.51,16.79-2.36,29.32c-5.22,16.9-27.52,29.57-36.47,24.34C152.11,376,145.24,363.05,147.77,344.51Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M160,372.77c-1.83-5.16-3.84-13.82-.83-23,2.8-8.54,8.74-13.93,13.73-18.46,9.91-9,13.75-7.19,17.28-13.49,4.87-8.7-1.21-14.37,4-22.49,3.92-6.07,8.69-5,14.2-11.36,5.29-6.08,6.57-13.57,6.87-18.7",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M145.94,375c1.91-4.57,5.82-11.59,13.44-15.92,7.06-4,14.32-4,20.42-4,12.1,0,13.58,3.54,19.77,1.47,8.55-2.87,7.93-10.36,16.37-12.62,6.31-1.68,8.86,1.93,16.41,1,7.24-.86,12.65-5.1,16-8.35",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M71.8,361.37c-1.07-9-9.06-13.68-11.31-15.54-3.84-3.19-7.12-1.41-9.53-4.47-3.73-4.74,2.48-11.2-.81-17.42-2.79-5.27-8.18-2.41-13.39-8.76-4-4.9-2.35-8.49-7.39-13.86-1.9-2-4.79-5.1-8.2-4.65-4.82.63-9.26,8.13-8,13.54,1.5,6.34,9.85,5.53,11.86,12.22,1.93,6.4-4.74,10.42-2.63,16.16s10,4.29,14.69,10.36-1.22,11.9,1.34,20.75c3.44,11.94,18.77,20.76,25,17C68.48,383.68,73.37,374.49,71.8,361.37Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M54.65,369a21.19,21.19,0,0,0,1.15-13.53c-1.41-5.11-4.75-8.45-7.56-11.26-5.57-5.58-7.89-4.63-9.78-8.44-2.62-5.26,1.12-8.43-1.73-13.35-2.13-3.69-5-3.21-8-7.1a18.23,18.23,0,0,1-3.51-11.21",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 43.32,
    y: 153.09,
    width: 134.37,
    height: 215.68,
    transform: "translate(-13.26 -48.25) rotate(-0.07)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 39.46,
    y: 208.77,
    width: 52.37,
    height: 52.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 98.23,
    y: 208.77,
    width: 52.37,
    height: 52.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 39.46,
    y: 267.54,
    width: 52.37,
    height: 52.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 98.23,
    y: 267.54,
    width: 52.37,
    height: 52.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 50,
    cy: 187.06,
    r: 10.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M63,244.16a8.72,8.72,0,1,1,8.72-8.72A8.73,8.73,0,0,1,63,244.16Zm0-16.46a7.74,7.74,0,1,0,7.73,7.74A7.74,7.74,0,0,0,63,227.7Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 80.02,
    cy: 187.06,
    r: 10.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M93,244.16a8.72,8.72,0,1,1,8.72-8.72A8.73,8.73,0,0,1,93,244.16Zm0-16.46a7.74,7.74,0,1,0,7.74,7.74A7.74,7.74,0,0,0,93,227.7Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 110.04,
    cy: 187.06,
    r: 10.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M123,244.16a8.72,8.72,0,1,1,8.72-8.72A8.74,8.74,0,0,1,123,244.16Zm0-16.46a7.74,7.74,0,1,0,7.73,7.74A7.75,7.75,0,0,0,123,227.7Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 140.06,
    cy: 187.06,
    r: 10.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M153,244.16a8.72,8.72,0,1,1,8.72-8.72A8.73,8.73,0,0,1,153,244.16Zm0-16.46a7.74,7.74,0,1,0,7.73,7.74A7.75,7.75,0,0,0,153,227.7Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "47.81 183.72 47.81 190.4 52.48 187.06 47.81 183.72"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 76.6,
    y: 186.35,
    width: 6.66,
    height: 4.63
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "84.3 186.72 75.56 186.72 77.16 183.51 82.7 183.51 84.3 186.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M93.75,239.35H92v-2.22a.85.85,0,0,1,.85-.86h0a.85.85,0,0,1,.86.86Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M138.61,213.05l-3.36-3.2a1.84,1.84,0,0,1,2.92-2.23l.47.62.41-.54a1.83,1.83,0,1,1,2.93,2.2Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "110.04 188.29 105.81 185.12 105.81 190.34 114.27 190.34 114.27 185.12 110.04 188.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "114.01 184.07 106.07 184.07 110.04 187.06 114.01 184.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M73.43,213.48h0a21,21,0,0,1-20.94-20.94h0A21,21,0,0,1,73.43,171.6h0a20.94,20.94,0,0,1,20.93,20.94h0A20.94,20.94,0,0,1,73.43,213.48Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M82.52,204.71a9.09,9.09,0,1,0-18.18,0Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M73.43,196.54h0a6.19,6.19,0,0,1-6.19-6.2v-5.61a6.2,6.2,0,0,1,6.19-6.2h0a6.2,6.2,0,0,1,6.19,6.2v5.61A6.19,6.19,0,0,1,73.43,196.54Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M70.2,190a3.23,3.23,0,1,0,6.46,0Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 90.61,
    cy: 206.18,
    r: 8.1,
    transform: "translate(-140.38 214.21) rotate(-80.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M89.77,210.23l-3.83-4a1,1,0,0,1,1.43-1.36l2.39,2.51,4-4.25a1,1,0,0,1,1.39,0,1,1,0,0,1,0,1.4Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M126.37,179.52h-17.1a1,1,0,1,1,0-2h17.1a1,1,0,1,1,0,2Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M145.92,185.79H109.27a1,1,0,0,1,0-2h36.65a1,1,0,1,1,0,2Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M134.67,192.06h-25.4a1,1,0,1,1,0-2h25.4a1,1,0,0,1,0,2Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M145.92,198.32H109.27a1,1,0,1,1,0-2h36.65a1,1,0,1,1,0,2Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M153.92,211.28h-8.85a1,1,0,0,1,0-2h8.85a1,1,0,1,1,0,2Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M148.24,319.88c-.26,5.58-3.32,46.53-3.52,48.54-.16,1.6-11.2,1.92-11.26,1.21-.32-3.93-4.28-47-4.54-49.86-.44-4.76,3.82-17.32,5.55-24.43L153.22,299C152.54,304.57,148.24,319.88,148.24,319.88Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M133.18,366.83l-19.06,10.8a2.24,2.24,0,0,0,1.18,4.19l31.09-.84c2.35-.15-1.27-16.14-1.27-16.14L144,366.25a7.35,7.35,0,0,1-10.77.58Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 127.74,
    y: 361.99,
    width: 4.54,
    height: 36.06,
    rx: 1.12,
    transform: "translate(-259.65 471.01) rotate(-91.42)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M132.83,372a.93.93,0,0,0,.55-.18,1,1,0,0,0,.21-1.35l-2.14-2.92a1,1,0,0,0-1.56,1.14l2.14,2.92A1,1,0,0,0,132.83,372Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M129.68,373.9a1,1,0,0,0,.55-.18,1,1,0,0,0,.21-1.35l-2.15-2.92a1,1,0,1,0-1.55,1.14l2.14,2.92A1,1,0,0,0,129.68,373.9Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M126.28,375.89a1,1,0,0,0,.55-.19,1,1,0,0,0,.21-1.35l-2.14-2.92a1,1,0,0,0-1.56,1.14l2.14,2.92A1,1,0,0,0,126.28,375.89Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M144.18,252.46l27.61-5.57S175.14,275,161,286.42c-3.6,2.91-7.61,15-9.59,23.84l-24.16-3.69C132.41,289.61,144.18,252.46,144.18,252.46Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M172,136.91l-123.26.15a10.48,10.48,0,0,0-10.48,10.5l.26,228.57A10.49,10.49,0,0,0,49,386.61l123.26-.14A10.49,10.49,0,0,0,182.74,376l-.26-228.58A10.5,10.5,0,0,0,172,136.91Zm5.8,231.79-134.37.15-.22-215.68L177.56,153Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M125,380.34l-28,0a2.51,2.51,0,0,1-2.53-2.52h0A2.52,2.52,0,0,1,97,375.33l28,0a2.52,2.52,0,0,1,2.53,2.52h0A2.52,2.52,0,0,1,125,380.34Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M114.6,145.4a3.84,3.84,0,1,1-3.85-3.83A3.84,3.84,0,0,1,114.6,145.4Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 30.47,
    y: 104.64,
    width: 134.14,
    height: 7.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M155.4,175.18c-7.33,4.76-11,18.32-9.83,27.75,3.69,29.46,26,51.42,41.59,49,12.09-1.87,28-18.37,23.05-27.23-5.11-9.07-12.11-12.42-19.94-23.81-5.21-7.59-3.23-14.41-6.47-19.18C178.88,174.48,168.6,166.6,155.4,175.18Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "223.16 202.24 223.34 193.52 193.35 184.66 170.29 161.87 158.68 175.83 184.42 196.78 223.16 202.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M242.28,247.81l-3-5.27-4.11-.49s-4.29,4.2,1.38,10.73a3.16,3.16,0,0,0,1.48.95Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M241,244.42l-.74-1.67c-.3-.77.34-1.22.85-1.87l1.85-1.82a.46.46,0,0,0-.15-.76,2.87,2.87,0,0,0-3.08.28l-5,3.6Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "107.62 224.99 116.22 226.46 129.45 198.13 148 167.76 137.81 156.29 118.8 187.49 107.62 224.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M119.44,279.38,118,286.8a1.36,1.36,0,0,1-.3.6c-.46.5-1.44,1.49-1.69.87-.34-.81,1.11-8.86,1.11-8.86",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M128.1,277.7l-1.68,1.66a3.32,3.32,0,0,0-.72,1l-2.5,6.29s-1.32,1.57-1.86.77.81-7.9.81-7.9l-1.71,8.57a1.09,1.09,0,0,1-.24.48c-.47.54-1.71,1.83-2,1.08-.38-.92,1.27-10.11,1.27-10.11",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M115.28,286.32a3.64,3.64,0,0,0,1-1.3l.65-5,5.54-.13,5.65-2.17,1.1-4s-3.52-4.87-10.82-.23a3.22,3.22,0,0,0-1.16,1.32l-2.17,4.6a1.57,1.57,0,0,0,0,.3c-.07,1-.89,6.23-.74,6.6C114.35,286.51,115,286.51,115.28,286.32Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M126,279.06l1.75-.48c.81-.18,1.16.52,1.73,1.12l1.52,2.1a.47.47,0,0,0,.78,0,2.86,2.86,0,0,0,.18-3.09l-2.81-5.51Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M172.93,195l-.34.66a3.44,3.44,0,1,1-4.66,1.47,3.54,3.54,0,0,1,1-1.2,3.37,3.37,0,0,1-.4-.63,4.24,4.24,0,0,0-1.3,1.49,4.21,4.21,0,0,0,1.8,5.66,4.2,4.2,0,1,0,3.86-7.45Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M199.4,337.7c3.25,4.54,8.17,13.36,9.15,15.13.77,1.4-8.14,8.16-8.59,7.61-2.5-3.06-9.27-11.45-11.08-13.63-3-3.68-24.47-32.25-27.9-36.9L180.54,299C183.12,304,197.7,335.33,199.4,337.7Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M198.14,358.29,188.53,378a2.24,2.24,0,0,0,3.33,2.79L217,362.49c1.86-1.45-10.17-12.59-10.17-12.59l-.16,1.82a7.35,7.35,0,0,1-8.56,6.57Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 200.72,
    y: 352.93,
    width: 4.54,
    height: 36.06,
    rx: 1.12,
    transform: "translate(8.18 704.36) rotate(-125.84)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M200.22,362.91a1,1,0,0,0,.3-1.88l-3.42-1.2a1,1,0,0,0-.64,1.83l3.42,1.19A1,1,0,0,0,200.22,362.91Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M198.71,366.28a.94.94,0,0,0,.89-.64,1,1,0,0,0-.59-1.23l-3.42-1.2a1,1,0,0,0-1.23.59A1,1,0,0,0,195,365l3.42,1.2A.8.8,0,0,0,198.71,366.28Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M197,369.84a1,1,0,0,0,.89-.65,1,1,0,0,0-.59-1.23l-3.42-1.2a1,1,0,0,0-.64,1.83l3.42,1.19A1,1,0,0,0,197,369.84Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M150.9,253.71l24.48-8.21s11.15,19.08,8,37c-1.32,7.58,2.53,17.13,4.42,23.89l-28.75,7C153.75,296.53,150.9,253.71,150.9,253.71Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M142.44,258.79c1.07-3.88,1.74-6.33,1.74-6.33l26.26-5.3,4.94-1.66a74.16,74.16,0,0,1,6.16,14.88c-1.78.39-3.73.75-5.83,1.05a75.07,75.07,0,0,1-27.57-1.21A57.78,57.78,0,0,1,142.44,258.79Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M156.14,202.61,172.87,205c1.56.22,9.87,3.73,10.38,5.21.19.55-.71,9.19-1.82,14.09l-5,20.1,4.34,11a110.48,110.48,0,0,1-24.86,1.94c-6-.28-9.06-1.76-14.34-4.87l2.72-16.66a29.23,29.23,0,0,1,5-29.32c.86-1,2.63-3.69,3.62-4A5.64,5.64,0,0,1,156.14,202.61Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M172,189.63l.61,15.16c-.14,1.64-3.9,6.4-8.67,6.43-2.61,0-4.83-1.78-4.42-4.37l1.81-11.58Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M160,204.17l1.14-7.52,9-1.91-.35,2.09S168.47,200.3,160,204.17Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M159.22,193.23a6.91,6.91,0,0,0,7.41,7.13l7.53-.55a5.9,5.9,0,0,0,5.3-7.75l-2.66-12.67-16.92-5.71Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M176.8,179.39c.46.78-12.14-2.09-16.62,14l-2.32.49s-10.9-6.59-3.11-17.55C159.23,170.06,172.11,171.44,176.8,179.39Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M157.84,195a3.83,3.83,0,1,0,.3-5.41A3.84,3.84,0,0,0,157.84,195Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M160.7,194.09l-.65.36a3.45,3.45,0,1,1-6,3.34,3.43,3.43,0,0,1,2.87-5.12,3.76,3.76,0,0,1,0-.75,4.17,4.17,0,0,0-1.91.52,4.1,4.1,0,0,0-2,2.51,4.2,4.2,0,1,0,7.7-.86Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "148.66 144.69 146.77 143.06 146.95 142.88 148.84 144.51 148.66 144.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "147.06 144.71 146.87 144.54 148.55 142.85 148.74 143.02 147.06 144.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M175.07,185.89a.57.57,0,0,0,1.14-.08.56.56,0,0,0-.61-.53A.57.57,0,0,0,175.07,185.89Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M177.56,183.42l2.42,3.11a1,1,0,0,1-.07,1.34l-1.17,1.21Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M153.46,302.39c-.53-3,0-22.61.39-21.24.94,3.56.66,11.84,1.61,15.27C154.68,298.91,154.15,299.53,153.46,302.39Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M172.88,189.68a11,11,0,0,0,5.64.84S174.91,195.42,172.88,189.68Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M164.55,211.83c5.66-.09,8.43-5.22,9.09-6.66-.26,0-.51-.1-.77-.13l-.25,0c-.85,1.78-4,7.12-10.52,5.55a2.55,2.55,0,0,1-1.52-1.19c-.59-.92-1.11-2.74-.37-6.16l-1-.14c-.64,3-.47,5.34.54,6.88a3.57,3.57,0,0,0,2.14,1.59A10.17,10.17,0,0,0,164.55,211.83Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "257.05 208.82 272.64 219.08 272.82 213.51 285.87 217.59 268.9 203.85 268.69 210.52 257.05 208.82"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 265.09,
    y: 237.12,
    width: 9.37,
    height: 10.69,
    transform: "translate(-36.7 407.22) rotate(-77.93)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M258.24,270.84l-7.17-1.54a17.41,17.41,0,1,1,7.28-34.06l7.18,1.53-2,9.16-7.18-1.53A8,8,0,1,0,253,260.14l7.18,1.54Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 259.77,
    y: 262.03,
    width: 9.37,
    height: 10.69,
    transform: "translate(-65.26 421.71) rotate(-77.93)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M247,251.41l-1.21-3.6a1.61,1.61,0,0,1-.12-.87c.11-.92.44-2.79,1.15-2.37.94.55,2.66,4.78,2.66,4.78",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M245.3,253.39l-1.22-3.61a1.6,1.6,0,0,1-.12-.87c.11-.92.44-2.78,1.16-2.36.93.55,2.65,4.77,2.65,4.77",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M243.61,255.36l-1.22-3.6a1.87,1.87,0,0,1-.12-.88c.12-.92.44-2.78,1.16-2.36.94.55,2.65,4.77,2.65,4.77",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M244,254.81s-1.32-3.77-2.26-4.32c-.71-.42-1,1.44-1.15,2.36a1.63,1.63,0,0,0,.12.88l.68,2a1.76,1.76,0,0,0,2.28,1.13c1.63-.54,3.58-3.21,5.32-5.47,2.84-3.68,1.09-5.7,1.09-5.7l-1.73,1.41Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "147.99 167.26 149.86 173.15 155.78 174.95 150.75 178.56 150.86 184.74 145.89 181.07 140.04 183.09 141.99 177.22 138.26 172.29 144.45 172.33 147.99 167.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M129.31,211.28h-8.85a1,1,0,0,1,0-2h8.85a1,1,0,1,1,0,2Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M117.07,208.14v0a.7.7,0,0,0-.71-.7h-1.85a3.6,3.6,0,0,0,.32-2.09c0-.3-.09-.87-.63-.87a.65.65,0,0,0-.65.5l0,.52a.39.39,0,0,1-.1.25l-1.81,2h0a.32.32,0,0,0-.1.22v4.58a.44.44,0,0,0,.38.43h4.49a.71.71,0,0,0,.71-.71v0a.72.72,0,0,0-.51-.68.7.7,0,0,0,.51-.67v0a.7.7,0,0,0-.51-.67.72.72,0,0,0,.51-.68v0a.71.71,0,0,1,0-1.36Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 95.66,
    y: 159.42,
    width: 2.37,
    height: 5.18,
    rx: 0.32
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "365.73 222.7 375.81 224.37 389.6 203.37 406.56 168.41 390.8 159.57 376.12 196.81 365.73 222.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M417.12,206.4l-2.49-1.54a7.83,7.83,0,0,0-10.77,2.54l-11.42,21.39,15.67,10,11.55-21.61A7.81,7.81,0,0,0,417.12,206.4Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M468,335.84c3.8,4.74,10.77,14.93,11.94,16.8.93,1.48-9.45,8.47-10,7.9-2.9-3.17-10.78-11.9-12.87-14.16-3.54-3.82-7.67-8.5-11.68-13.36l14.16-10.28A141.31,141.31,0,0,0,468,335.84Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M467.87,358.31l-9.28,22a2.44,2.44,0,0,0,3.8,2.83l26.29-21.39c1.93-1.69-11.82-13.09-11.82-13.09l-.07,2a8,8,0,0,1-8.92,7.66Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 471.44,
    y: 352.16,
    width: 4.94,
    height: 39.29,
    rx: 1.12,
    transform: "translate(470.3 925.71) rotate(-129.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M470.41,363.21a1,1,0,0,0,.93-.75,1.06,1.06,0,0,0-.71-1.31l-3.8-1.09a1.05,1.05,0,1,0-.58,2l3.79,1.1A1.16,1.16,0,0,0,470.41,363.21Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M469,367a1.05,1.05,0,0,0,.22-2.06l-3.8-1.1a1.05,1.05,0,0,0-.58,2l3.79,1.1A1.17,1.17,0,0,0,469,367Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M467.35,370.94a1.05,1.05,0,0,0,.22-2.06l-3.8-1.09a1.05,1.05,0,1,0-.58,2l3.79,1.1A1.18,1.18,0,0,0,467.35,370.94Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M414.78,272.66l23.41-20.92s15.37,20,11.3,37.13c-2.75,11.58,9.61,30.32,19,37.65l-25.08,18.31a76.36,76.36,0,0,1-11.61-20.29C425.8,308.53,414.78,272.66,414.78,272.66Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M414.49,349.38c0,6.21-.9,18.78-1.16,21-.2,1.77-12.93.74-13,0-.29-4.38-1-16.36-1.26-19.5-.4-5.3-.71-11.67-.82-18.1l17.85.8A146,146,0,0,0,414.49,349.38Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M400.08,367.23l-21.41,11.66a2.49,2.49,0,0,0,1.23,4.68l34.61-.34c2.62-.13-1.11-18-1.11-18l-1.33,1.55a8.17,8.17,0,0,1-12,.43Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 393.78,
    y: 361.8,
    width: 5.05,
    height: 40.12,
    rx: 1.12,
    transform: "translate(4.58 732.75) rotate(-90.45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M399.6,373a1.1,1.1,0,0,0,.62-.19,1.08,1.08,0,0,0,.25-1.5L398.14,368a1.07,1.07,0,1,0-1.75,1.24l2.33,3.29A1.06,1.06,0,0,0,399.6,373Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M396.05,375a1,1,0,0,0,.62-.2,1.07,1.07,0,0,0,.26-1.49l-2.34-3.29a1.07,1.07,0,1,0-1.75,1.24l2.33,3.29A1.09,1.09,0,0,0,396.05,375Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M392.24,377.18a1,1,0,0,0,.62-.2,1.07,1.07,0,0,0,.25-1.49l-2.33-3.3a1.08,1.08,0,0,0-1.75,1.25l2.33,3.29A1.09,1.09,0,0,0,392.24,377.18Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M407.7,265.42l30.43-4.93s7.89,27.47-5.95,38.3c-9.37,7.34-13.72,35.67-10.93,47.27l-31-1.32c-.15-8.55,4.36-28.1,6.16-33.67C401.67,294.79,407.7,265.42,407.7,265.42Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M423.76,314.29c-.47-2.91-.66-18.41-.33-17.08.86,3.45,1.73,7.35,2.59,10.67C425.23,310.27,424.3,311.86,423.76,314.29Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M410.51,203.69l25,.58c10.86,1,14.32,7.44,14.26,13.38l-.45,28.22,4.79,29.33-52.09,3-1.36-50.63c-1.38-7.09.4-14.22,4-20.49a6.61,6.61,0,0,1,2.31-2.45A6.4,6.4,0,0,1,410.51,203.69Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M425.58,190.73l1.67,13c.23,1.74-3.19,6.84-7.58,8.65a4.08,4.08,0,0,1-5.6-3.55l-.73-12.49Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M413.66,201.75l-.32-5.62,8.81-6.51.11,2.26S421.64,195.8,413.66,201.75Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M426.1,194.76l-15.51,3.52a6.54,6.54,0,0,1-6-1.69,6.45,6.45,0,0,1-1.8-4.54l.83-14.56,20.27-4.75Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M400.92,174.11c1.87,10.12,17.19,1,17.49,5.39.76,11.28,7,8.7,7,8.7s8-16.86-2-17.09S398.16,159.16,400.92,174.11Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M428.4,184.29a4.22,4.22,0,1,1-5.07-3.14A4.22,4.22,0,0,1,428.4,184.29Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M404.16,180.5,401,186.07c-.48.83.22,1.7,1.31,1.62l2.22-.28Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "410.68 138.19 410.44 138.05 411.99 135.55 412.23 135.69 410.68 138.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "412.51 137.77 410.01 136.22 410.16 135.98 412.66 137.53 412.51 137.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M407.39,183.57a.61.61,0,1,1-1.19.27.62.62,0,0,1,.46-.73A.61.61,0,0,1,407.39,183.57Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M434.75,213.55l2.19-2c3.23-2.9,5.6-5.2,8.5-2l28.61,31.81-1.52,29.27c.57,4.28,2.83,11.08,1.35,13.13-1,1.34-1.3.34-2.69.86a3.85,3.85,0,0,1-2.54.33c-1.53-.05-2.59,1.13-3.56.33s-1.15-.76-2.77-1.17-.29-4.16-.11-7l-1.83,2.51c-.92.82-1.48.33-1.62-.33a4,4,0,0,1,0-1.59,10.92,10.92,0,0,1,3.28-5.87l1.22-1.15-2.86-23.22L433.3,220.71C430.4,217.48,431.53,216.45,434.75,213.55Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M434.5,207.38l-2.14,2a7.83,7.83,0,0,0-.4,11.06l16.3,17.86L462,225.83l-6.23-7-10.24-11A7.83,7.83,0,0,0,434.5,207.38Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M407.6,189.66a4.69,4.69,0,0,0,1.58-1.78.11.11,0,0,0-.05-.17.13.13,0,0,0-.17,0c-1.54,2.82-3.83,2.14-3.92,2.11a.13.13,0,0,0-.16.09.12.12,0,0,0,.08.15A3.35,3.35,0,0,0,407.6,189.66Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M405.53,187.31a4.07,4.07,0,0,1-2-4.82h0a4.07,4.07,0,1,1,2.67,5.1A4.48,4.48,0,0,1,405.53,187.31Zm-1.23-4.57a3.25,3.25,0,1,0,4.08-2.14,3.26,3.26,0,0,0-4.08,2.14Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M411,183.85l-.11-.77a47.81,47.81,0,0,1,8.9-.37l-.07.77A45.9,45.9,0,0,0,411,183.85Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M392.75,141.29a21.08,21.08,0,1,0-9.93,17.84,26.2,26.2,0,0,0,9.38,1.13l-4.09-5.8A20.92,20.92,0,0,0,392.75,141.29Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M382,137.06V137a1.89,1.89,0,0,0-1.88-1.89h-5c1.06-1.42,1-4.83.86-5.61s-.25-2.33-1.71-2.33a1.76,1.76,0,0,0-1.75,1.33l-.11,1.41a1.13,1.13,0,0,1-.29.66L367.29,136h0a.8.8,0,0,0-.25.59v12.29a1.17,1.17,0,0,0,1,1.16v0h12.09a1.89,1.89,0,0,0,1.88-1.89v-.06a1.88,1.88,0,0,0-1.37-1.82,1.88,1.88,0,0,0,1.37-1.82v-.06a1.88,1.88,0,0,0-1.37-1.82,1.88,1.88,0,0,0,1.37-1.82v-.06a1.88,1.88,0,0,0-1.37-1.82A1.88,1.88,0,0,0,382,137.06Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 346.36,
    y: 87.76,
    width: 6.36,
    height: 13.91,
    rx: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M378.69,271.08l-1.79,10.07a2.27,2.27,0,0,0,.06,1l2.74,9.13a2.12,2.12,0,0,0,2,1.51h0a2.13,2.13,0,0,0,2.06-1.63l1.86-7.83,3.24-10.89Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M387.86,273.09l1.7,9.09a.59.59,0,0,1-.82.65c-.83-.41-2-1.46-3.09-4.13C383.84,274.12,387.86,273.09,387.86,273.09Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 199.4,
    cy: 119.98,
    r: 1.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M200.15,168.35a20.07,20.07,0,1,1,9.45,17,24.86,24.86,0,0,1-8.93,1.07l3.9-5.51A20,20,0,0,1,200.15,168.35Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M214,168.05a2.13,2.13,0,1,1-2.13-2.13A2.13,2.13,0,0,1,214,168.05Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M222.3,168.05a2.13,2.13,0,1,1-2.12-2.13A2.12,2.12,0,0,1,222.3,168.05Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M230.63,168.05a2.13,2.13,0,1,1-2.13-2.13A2.13,2.13,0,0,1,230.63,168.05Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M316.26,156.67a21.08,21.08,0,1,0-9.93,17.84,26,26,0,0,0,9.38,1.12l-4.09-5.79A20.94,20.94,0,0,0,316.26,156.67Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M295.18,164.6l-8.62-8.06a4.67,4.67,0,1,1,7.36-5.75l1.22,1.57,1-1.39a4.67,4.67,0,1,1,7.51,5.55Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "338.93 230.36 330.91 227.03 327.04 193.67 316.47 165.57 334.47 162.15 344.65 198.68 338.93 230.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M349.66,284.4l-2.7,7a1.24,1.24,0,0,0-.06.66c.11.67.42,2,1,1.63.71-.5,3.77-8.05,3.77-8.05",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M343.27,278.39l.54,2.29a3.69,3.69,0,0,1,.06,1.24l-1.24,6.62s.27,2,1.15,1.63,3.51-7.08,3.51-7.08l-3.1,8.12a1,1,0,0,0-.06.53c.11.7.46,2.44,1.12,2s4.29-9.18,4.29-9.18",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M349.47,292.45a3.54,3.54,0,0,1-.13-1.62l2.12-4.57-4.59-3.05-3.6-4.82,1.2-3.94s5.54-2.22,9.21,5.55a3.13,3.13,0,0,1,.28,1.73l-.62,5a2.33,2.33,0,0,1-.11.28c-.48.88-2.57,5.71-2.89,5.94S349.62,292.76,349.47,292.45Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M344.31,280.65l-1.22-1.34c-.57-.58-1.25-.17-2,0l-2.4,1a.46.46,0,0,1-.63-.44,2.82,2.82,0,0,1,1.49-2.69L344.8,274Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M361.19,324.87c3.15,4.57,18.05,27.22,19,29,.75,1.41-8.23,8-8.66,7.42-2.43-3.08-21.14-25.6-22.9-27.8-3-3.71-15.85-35-19.19-39.69l22.2-8.13C354.11,290.67,359.54,322.49,361.19,324.87Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M369.74,359.12l-9.89,19.41a2.23,2.23,0,0,0,3.27,2.83l25.34-17.74c1.87-1.42-9.9-12.69-9.9-12.69l-.2,1.81a7.3,7.3,0,0,1-8.62,6.38Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 372.09,
    y: 353.88,
    width: 4.51,
    height: 35.86,
    rx: 1.12,
    transform: "translate(270.36 843.13) rotate(-124.87)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M371.73,363.75a1,1,0,0,0,.33-1.86l-3.38-1.25a1,1,0,0,0-1.23.57,1,1,0,0,0,.57,1.23l3.38,1.25A1,1,0,0,0,371.73,363.75Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M370.17,367.08a1,1,0,0,0,.34-1.86L367.12,364a1,1,0,1,0-.66,1.8l3.38,1.25A1,1,0,0,0,370.17,367.08Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M368.44,370.59a1,1,0,0,0,.33-1.87l-3.38-1.24a1,1,0,1,0-.66,1.8l3.38,1.25A1,1,0,0,0,368.44,370.59Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M322.39,325.12c0,5.55-5.7,41.18-5.93,43.18-.18,1.58-11.17,1.71-11.21,1-.26-3.92-.14-43.12-.35-45.93-.35-4.73,7.8-31.89,7.7-37.65l23,1.36C334.79,292.62,322.38,322.22,322.39,325.12Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M305,366.52l-19.13,10.41a2.23,2.23,0,0,0,1.1,4.19l30.93-.31c2.34-.11-1-16.07-1-16.07l-1.19,1.38a7.3,7.3,0,0,1-10.72.4Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 299.39,
    y: 361.65,
    width: 4.51,
    height: 35.86,
    rx: 1.12,
    transform: "translate(-88.55 635.79) rotate(-90.45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M304.58,371.63a1,1,0,0,0,.55-.18,1,1,0,0,0,.23-1.34l-2.08-2.94a1,1,0,0,0-1.57,1.11l2.08,2.94A1,1,0,0,0,304.58,371.63Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M301.41,373.49a.92.92,0,0,0,.55-.17,1,1,0,0,0,.23-1.34L300.11,369a1,1,0,0,0-1.34-.23,1,1,0,0,0-.23,1.34l2.09,2.94A1,1,0,0,0,301.41,373.49Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M298,375.41a.93.93,0,0,0,.55-.18,1,1,0,0,0,.23-1.34L296.7,371a1,1,0,0,0-1.57,1.11l2.09,2.94A1,1,0,0,0,298,375.41Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M330.61,203.63l16.6,2.69a15.48,15.48,0,0,1,4.45,1.4c7.53,3.76,8,13.94,6.86,18.78l-6.89,27.33,2.6,14.26-7.78,2.41a47.89,47.89,0,0,1-17.75,2.12c-5.93-.43-9-1.9-14.17-5.08h0l3.05-25.38c-7-13.7,2.42-31.78,7-36.71a6.2,6.2,0,0,1,2.77-1.78A5.92,5.92,0,0,1,330.61,203.63Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M320,208.87s8.69,13.55,42.73,10.84",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M322.05,203.06s8.69,13.55,42.74,10.84",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M317.19,215.46s8.69,13.55,42.74,10.84",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M314.43,222.05s8.69,13.55,42.74,10.84",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M312.34,229.23s8.69,13.55,42.74,10.84",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M311.61,236.71s8.69,13.55,42.74,10.84",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M312.37,246.27s10.07,12.56,43.64,6.28",
    transform: "translate(-12.97 -48.38)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M315.61,258.55h0a52.79,52.79,0,0,0,24.46-.19l11.85-2.92s4.35,14,9.27,45.3l-28.14,5c-9.71.95-19.05-2.64-28.15-6.15h0C310.34,282.81,315.61,258.55,315.61,258.55Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M345.42,191l.35,15.09c-.16,1.63-4.35,5.53-8.73,6.24a3.79,3.79,0,0,1-4.32-4.41l2-11.49Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M333.18,205.25l.91-5.18,9.39-4-.39,2.08S341.7,201.55,333.18,205.25Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M345.59,200.73l-15.16-.11a6.05,6.05,0,0,1-5.12-2.83,6,6,0,0,1-.65-4.5l1.8-12.75L345,182.06Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M326.46,180.54c-.54.72,13.8,14,17.42,12.82l2.33.34s10.38-7.27,1.92-17.62C343.27,170.13,330.9,174.48,326.46,180.54Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M328.6,186.87a.57.57,0,1,1-.56-.57A.56.56,0,0,1,328.6,186.87Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M328.15,193a5,5,0,0,0,2.13-1.28.13.13,0,0,0-.19-.19c-2.4,2.33-4.47,1-4.56.9a.13.13,0,0,0-.18,0,.13.13,0,0,0,0,.18A3.55,3.55,0,0,0,328.15,193Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M326,184.58l-2.2,3.25a1,1,0,0,0,.16,1.33l1.24,1.12Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "295.88 236.12 292.11 228.3 311.41 200.82 322.2 172.8 337.92 182.23 321.22 216.27 295.88 236.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M304,287.57l-6.23,4.23a1.34,1.34,0,0,0-.43.51c-.29.61-.81,1.89-.14,1.88.87,0,7.69-4.44,7.69-4.44",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M302.22,279l-.87,2.19a3.48,3.48,0,0,1-.65,1.05L295.9,287s-.93,1.81,0,2,6.93-3.8,6.93-3.8L295.65,290a1.15,1.15,0,0,0-.35.41c-.31.64-1,2.27-.22,2.26,1,0,8.78-5.07,8.78-5.07",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M299.28,294.07a3.53,3.53,0,0,1,.81-1.4l4.35-2.54-2-5.12-.2-6,3.24-2.55s5.82,1.35,4.39,9.83a3.21,3.21,0,0,1-.76,1.57l-3.38,3.77-.25.16c-.9.46-5.37,3.22-5.77,3.22C299.46,295,299.22,294.41,299.28,294.07Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M301.79,281.44l-.24-1.79c-.14-.81-.92-.86-1.69-1.15l-2.52-.58a.46.46,0,0,1-.26-.72,2.82,2.82,0,0,1,2.76-1.36l6.13.44Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M349.88,175.84a1,1,0,1,1-1-1A1,1,0,0,1,349.88,175.84Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M329.85,174.5l20.7,15.84S358.28,167,329.85,174.5Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M336.9,179.89s-14.66-9.33-8.56-9.15C336.49,171,336.9,179.89,336.9,179.89Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M342.05,190.28s13.43,3,11.52,15.53-18,11.71-21.76,12.53-7,5.81-6,9.3c0,0-9.58-5.35-2.89-16.22s22.21-10.4,19.79-15.29S342.05,190.28,342.05,190.28Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M346.3,194.73a3.81,3.81,0,1,1-.66-5.35A3.81,3.81,0,0,1,346.3,194.73Z",
    transform: "translate(-12.97 -48.38)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "329.54 144.93 331.3 143.19 331.12 143.03 329.35 144.76 329.54 144.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "331.13 144.85 331.31 144.67 329.53 143.1 329.35 143.28 331.13 144.85"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowOurServicesWork);
export default __webpack_public_path__ + "static/media/how-our-services-work.b7510eb88065217795eb4c3720743b7a.svg";
export { ForwardRef as ReactComponent };